import { connect } from 'react-redux';
import SurveyList from './SurveyList';
import { surveyTemplateListSelector } from '../../store/redux/selectors/surveyTemplateListSelector';
import { fetchSurveyTemplatesActions } from '../../store/redux/actions/surveyActions';

const mapDispatchToProps = dispatch => ({
  fetchSurveyTemplates: apiOptions => dispatch(fetchSurveyTemplatesActions.request(apiOptions))
});
export default connect(surveyTemplateListSelector, mapDispatchToProps)(SurveyList);
